export default "__VITE_ASSET__ge7tE$zp__"